import { put, takeEvery } from 'redux-saga/effects';
import { Actions as RouterActions } from 'router';
import { FailWithId, Types as ServiceTypes } from 'services/genericAPIGatewayService';
import { Service } from '../services';

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
function* pushbackSaga(action: FailWithId<Service>) {
  switch (action.service) {
    case Service.Sites:
    case Service.Brands:
    case Service.Groups:
      yield put(RouterActions.push('/error'));
      return;
    default:
      return;
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* pushbackOnInvalidClientId() {
  yield takeEvery(ServiceTypes.GET_FAILED, pushbackSaga);
}
